import { render, staticRenderFns } from "./PedidoTabelaFreteModal.vue?vue&type=template&id=9b265aa0"
import script from "./PedidoTabelaFreteModal.vue?vue&type=script&lang=js"
export * from "./PedidoTabelaFreteModal.vue?vue&type=script&lang=js"
import style0 from "./PedidoTabelaFreteModal.vue?vue&type=style&index=0&id=9b265aa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports